import React from 'react'
import "./index.css"

export default function Contact() {
    return (
        <section id="contact" className="section is-medium">
            <p className="title  is-family-code has-text-green">Get In Touch</p>
            <div className='columns'>
                <div className='column is-3'>
                    <br />
                    <text className='has-text-green'>Email</text>
                    <br />
                    <text className='has-text-white'>mandgenikhil@gmail.com</text>
                    <br />
                    <br />
                    <text className='has-text-green'>Contact</text>
                    <br />
                    <text className='has-text-white'>+1 (704)-906-9248</text>
                    <br />
                </div>
                <div className='column is-7'>
                    <div className="field is-horizontal">
                        <div className="field-label is-normal">
                            <label className="label">From</label>
                        </div>
                        <div className="field-body">
                            <div className="field">
                                <p className="control is-expanded has-icons-left">
                                    <input className="input is-success has-text-white" type="text" placeholder="Name" />
                                    <span className="icon is-small is-left">
                                        <i className="fas fa-user"></i>
                                    </span>
                                </p>
                            </div>
                            <div className="field">
                                <p className="control is-expanded has-icons-left has-icons-right">
                                    <input className="input is-success" type="email" placeholder="Email" />
                                    <span className="icon is-small is-left">
                                        <i className="fas fa-envelope"></i>
                                    </span>
                                    <span className="icon is-small">
                                        <i className="fas"></i>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="field is-horizontal">
                        <div className="field-label"></div>
                        <div className="field-body">
                            <div className="field is-expanded">
                                <div className="field has-addons">
                                    <p className="control">
                                        <a className="button is-static " href>
                                            +1
                                        </a>
                                    </p>
                                    <p className="control is-expanded">
                                        <input className="input is-success" type="tel" placeholder="Your phone number" />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="field is-horizontal">
                        <div className="field-label">
                        </div>
                    </div>
                    <div className="field is-horizontal">
                        <div className="field-label is-normal">
                        </div>
                        <div className="field-body">
                            <div className="field">
                                <div className="control">
                                    <textarea className="textarea is-success" placeholder="Explain how we can help you"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="field is-horizontal">
                        <div className="field-label">
                        </div>
                        <div className="field-body">
                            <div className="field">
                                <div className="control">
                                    <button className="button btn ">
                                        Send message
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
